import { Box, Button, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

export default function Bloque10({ text10, handleDatosTextField10 }) {

    useEffect(() => {
        console.log(text10)
    }, [text10])

    const [mostrar, setMostrar] = useState(false)

    const handleMostrar = () => {
        setMostrar(!mostrar)
    }


    return (
        <>
            {/* <Box style={{ marginTop: "50px" }} >
                <Typography variant="h4" >Fondoscopia</Typography>


                <Box style={{ marginTop: "10px", display: "flex", justifyContent: "space-between" }}>
                    {
                        text10.map((x) =>
                            <Box key={x.id} style={{ marginTop: "10px", width: "580px", marginRight: "20px" }}>
                                <Box style={{ textAlign: "center" }}>
                                    <Typography variant='h5'>{x.label}</Typography>
                                </Box>
                                <TextField
                                    label={x.label}
                                    multiline
                                    rows={3}
                                    fullWidth
                                    onChange={(e) => handleDatosTextField10(x.id, e.target.value, 'valor')}
                                />
                            </Box>
                            // 06169716 - 196378

                        )
                    }
                </Box>

            </Box> */}
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography style={{ fontSize: "17px", marginTop: "20px" }} ><b>Fundoscopía</b></Typography>
                <Button variant='outlined' style={{ marginTop: "20px" }} onClick={handleMostrar}>{mostrar ? "Ocultar Valores" : "Mostrar Valores"}</Button>
            </Box>
            {
                mostrar &&
                <TableContainer style={{ marginTop: "20px", marginBottom: "20px" }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ fontSize: "16px", textAlign: "left", color: "transparent" }} align="left"><b>Fondo de Ojo</b></TableCell>
                                <TableCell style={{ fontSize: "16px" }} align="center"><b>Ojo Derecho</b></TableCell>
                                <TableCell style={{ fontSize: "16px" }} align="center"><b>Ojo Izquierdo</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                text10.map((x, ix) =>

                                    <TableRow key={ix + 1} hover>
                                        <>
                                            <TableCell align="left">
                                                <Typography>
                                                    {x.titulo}
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField
                                                    multiline
                                                    rows={2}
                                                    name={x.derecho}
                                                    onChange={(e) => handleDatosTextField10(x.id, e.target.value, 'derecho')}
                                                    value={x.derecho}
                                                />
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField
                                                    multiline
                                                    rows={2}
                                                    name={x.izquierdo}
                                                    onChange={(e) => handleDatosTextField10(x.id, e.target.value, 'izquierdo')}
                                                    value={x.izquierdo}
                                                />
                                            </TableCell>
                                        </>
                                    </TableRow>
                                )
                            }
                        </TableBody>
                    </Table>

                </TableContainer>}

                <Divider style={{ marginTop: "15px" }} />

        </>
    )
}
